export const IS_AUTH = "IS_AUTH";
export const BLOCK_FETCHING = "BLOCK_FETCHING";
export const FUNCTIONS_HELPER = "FUNCTIONS_HELPER";
export const DOMAIN_NAME = "DOMAIN_NAME";
export const THEME_CSS = "THEME_CSS";
export const SLIDER_INDEX = "SLIDER_INDEX";
export const IS_CLOSED = "IS_CLOSED";
export const USER_INFO = "USER_INFO";
export const NEW_USER_INFO = "NEW_USER_INFO";
export const UPDATE_PASSWORD_INFO = "UPDATE_PASSWORD_INFO";
export const PAGE_TITLE = "PAGE_TITLE";
export const HEADER_PORTAL_CONTAINER = "HEADER_PORTAL_CONTAINER";
export const BUSINESS_INFO = "BUSINESS_INFO";
export const ACCESS_TOKEN = "ACCESS_TOKEN";
export const NEW_ACCOUNT_DATA = "NEW_ACCOUNT_DATA";
export const CLASS_SELECTED_DATE = 'CLASS_SELECTED_DATE';
export const CLASS_DATE_TYPE = 'CLASS_DATE_TYPE';
export const SANS_SELECTED_DATE = 'SANS_SELECTED_DATE';
export const SANS_DATE_TYPE = 'SANS_DATE_TYPE';

export const SERVICE_TAB_INDEX = 'SERVICE_TAB_INDEX';
export const BOOKING_VALID_DATES = 'BOOKING_VALID_DATES';
export const CLASS_BUY_PAGE_ID = 'CLASS_BUY_PAGE_ID';
export const SANS_BUY_PAGE_ID = 'SANS_BUY_PAGE_ID';
export const BUY_NEW_CLASS_OBJECT = 'BUY_NEW_CLASS_OBJECT';
export const BUY_NEW_SANS_OBJECT = 'BUY_NEW_SANS_OBJECT';
export const ADD_CREDIT_STATE = 'ADD_CREDIT_STATE';

export const BUY_CLASS_RECEIPT = 'BUY_CLASS_RECEIPT';
export const BUY_SANS_RECEIPT = 'BUY_SANS_RECEIPT';

export const OBJECT_TO_BUY = 'OBJECT_TO_BUY';
export const DIALOG_MESSAGE = 'DIALOG_MESSAGE';